import Redux = require("redux");


export const DUMMY = 'dummy action';

export const ACTION_CHANGE_METRIC = 'ACTION_CHANGE_METRIC';
export const ACTION_CHANGE_TIME = 'ACTION_CHANGE_TIME';
export const ACTION_CHANGE_WEEK = 'ACTION_CHANGE_WEEK';
export const ACTION_CHANGE_LEGEND = 'ACTION_CHANGE_LEGEND';

export interface iChangeMetric extends Redux.Action{
    metric: string;
}

export interface iChangeTime extends Redux.Action{
    time: string;
}

export interface iChangeWeek extends Redux.Action{
    week: number;
}

export interface iChangeLegend extends Redux.Action{
    legend: object[];
}


